package com.milta.core.localization.translations.fr

import com.milta.core.localization.RouteStrings
import com.milta.core.localization.RouteStringsCoreImpl
import com.milta.core.localization.RouteStringsExtraImpl

internal val Route = RouteStrings(
    core = RouteStringsCoreImpl(
    manualDeliveryTitle = "Nouvelle livraison",
    manualDeliverySubtitle = "Ajoutez une livraison à la tournée",
    recipientNameLabel = "Nom du destinataire",
    addressLabel = "Adresse",
    phoneNumberLabel = "Téléphone",
    deliveryTimeLimitLabel = "Heure limite",
    optionalSuffix = "(facultatif)",
    submitButton = "Ajouter et continuer",
    saveEditedDeliveryButton = "Enregistrer la modification",
    deliveryCreated = "Livraison ajoutée",
    errorRecipientNameRequired = "Le nom du destinataire est requis",
    errorRecipientNameTooLong = "Le nom est trop long (150 caractères max)",
    errorAddressRequired = "L'adresse est requise",
    errorAddressTooLong = "L'adresse est trop longue (255 caractères max)",
    errorPhoneTooLong = "Le téléphone est trop long (20 caractères max)",
    errorDuplicateDelivery = "Cette livraison est déjà dans la liste (même destinataire et adresse)",
    errorRouteNotFound = "Tournée introuvable",
    errorForbidden = "Vous n'êtes pas autorisé à modifier cette tournée",
    errorValidation = "Veuillez vérifier les champs saisis",
    errorGeneric = "Une erreur est survenue. Réessayez.",
    errorRouteNotInProgress = "Cette tournée n'est plus en cours. Impossible d'ajouter une livraison.",
    unknownRecipientLabel = "Non connu",
    driverHomeTitle = "Ma tournée",
    driverModeBadge = "Mode Livreur",
    routeStatusScheduled = "Planifiée",
    routeStatusInProgress = "En cours",
    routeStatusCompleted = "Terminée",
    routeStatusPartial = "Partielle",
    driversDepartedOne = "parti",
    driversDepartedMany = "partis",
    driversFinishedOne = "terminé",
    driversFinishedMany = "terminés",
    stopsDeliveredLabel = "Livrés",
    stopsInProgressLabel = "En cours",
    stopsTodoLabel = "À faire",
    stopsFailedLabel = "Échecs",
    stopsUntreatedLabel = "Non traités",
    stopsCountLabel = "arrêts",
    startRouteButton = "Démarrer la tournée",
    noRouteTitle = "Aucune tournée",
    noRouteSubtitle = "Aucune tournée ne vous est assignée pour le moment.",
    noRoutePastSubtitle = "Aucune tournée ne vous a été assignée pour cette date.",
    routeInProgressTitle = "Tournée en cours",
    routeCompletedTitle = "Tournée terminée",
    addStopButton = "Ajouter un arrêt",
    errorConflict = "La tournée a déjà été démarrée ou terminée.",
    greetingPrefix = "Bonjour",
    routeOfTheDayLabel = "TOURNÉE DU JOUR",
    noOtherRouteLabel = "Aucune autre tournée planifiée",
    routeLabel = "Tournée",
    importMenuTitle = "Importer des livraisons",
    importMenuSubtitle = "Plusieurs modes combinables — choisissez une source",
    importModeScanDocumentTitle = "Scanner un document",
    importModeScanDocumentDesc = "Photographiez une liste ou une étiquette de colis",
    importModePdfTitle = "Importer un PDF",
    importModePdfDesc = "Bons de livraison, fichier scanné",
    importModeExcelTitle = "Excel / CSV",
    importModeExcelDesc = "Votre propre format — colonnes détectées automatiquement",
    importModeManualTitle = "Saisie manuelle",
    importModeManualDesc = "Nom, adresse, téléphone, heure limite",
    photoSourceSheetTitle = "Comment souhaitez-vous ajouter la photo ?",
    photoSourceTakePhoto = "Prendre une photo",
    photoSourceChooseGallery = "Choisir dans la galerie",
    photoSourceChooseFiles = "Choisir une image dans les fichiers",
    createRouteTitle = "Créer une tournée",
    routeCardDetailLabel = "Détail",
    importReviewTitle = "Vérifier les livraisons importées",
    importReviewMissingGpsWarning = "Coordonnées GPS manquantes",
    importReviewRetryGeocodeAction = "Réessayer le géocodage",
    createRouteEmptyDrivers = "Aucun chauffeur dans votre équipe pour l'instant",
    editDeliveriesAction = "Modifier",
    moreDeliveriesLabel = "autres",
    addDeliveriesAction = "Ajouter des livraisons",
    manualEntryAddedConfirmPrefix = "Livraison ajoutée :",
    manualEntryMergedConfirmPrefix = "Colis ajouté à la livraison existante",
    manualEntryAddedCountLabel = "Livraisons ajoutées",
    manualEntryFinishButton = "Terminer",
    optimizeRouteButton = "Optimiser l'itinéraire",
    createRouteButtonNoOptimize = "Créer la tournée",
    errorNoEnterprise = "Aucune entreprise associée à votre compte",
    errorDriverNotFound = "Chauffeur introuvable",
    errorNoDeliveries = "Ajoutez au moins une livraison avant d'optimiser l'itinéraire",
    errorOptimizationUnavailable = "Le service d'optimisation est temporairement indisponible.",
    errorGeocodingFailed = "Certaines adresses n'ont pas pu être localisées. Modifiez l'adresse et réessayez.",
    dispatchTitle = "Optimisation",
    optimizedSuccessTitle = "Itinéraire optimisé !",
    optimizedSuccessSubtitleSuffix = "arrêts ordonnés pour le trajet le plus court",
    stopsStatLabel = "Arrêts",
    stopDetailTitlePrefix = "Arrêt",
    stopStatusCurrentLabel = "En cours",
    stopStatusUpcomingLabel = "À venir",
    stopStatusDeliveredLabel = "Livré",
    stopStatusFailedLabel = "Échec",
    stopRecipientLabel = "Destinataire",
    callActionLabel = "Appeler",
    noPhoneLabel = "Téléphone non renseigné",
    packagesCountLabel = "colis",
    navigateButton = "Naviguer",
    navigationUnavailableUnverifiedAddress = "Adresse non vérifiée : navigation indisponible pour cet arrêt.",
    deadlineBeforePrefix = "Avant",
    deadlinePastSuffix = "dépassée",
    validateStopAction = "Valider cet arrêt",
    teamDashboardTitle = "Tournées",
    todayDateLabel = "Aujourd'hui",
    statRoutesLabel = "Tournées",
    statDeliveriesLabel = "Livraisons",
    statCompletedLabel = "Terminées",
    teamSectionTitle = "Équipe",
    routeStartedAtPrefix = "Démarrée à",
    routeCompletedAtPrefix = "Terminée à",
    routeNotStartedLabel = "Non démarrée",
    emptyTeamRoutesTitle = "Aucune tournée ce jour-là",
    emptyTeamRoutesSubtitle = "Aucun chauffeur de l'équipe n'a de tournée planifiée pour cette date.",
    errorInvalidDate = "Date invalide",
    routeDetailTitle = "Détail tournée",
    driverEyebrowLabel = "Chauffeur",
    failedDeliveryTag = "Échec de livraison",
    driverLoadingCheckTitle = "Vérification du chargement",
    loadingCheckInstructionText = "Vérifiez que tous les colis prévus sont bien chargés dans le véhicule avant de prendre la route.",
    expectedPackagesLabel = "colis prévus pour cette tournée",
    confirmLoadCheckboxPrefix = "J'ai bien chargé les",
    confirmLoadCheckboxSuffix = "colis prévus pour cette tournée",
    reportDiscrepancyToggleLabel = "Signaler un écart",
    discrepancyNotePlaceholder = "Ex : j'ai chargé 9 colis au lieu de 11…",
    discrepancyNoteTooLong = "Note trop longue — 500 caractères maximum.",
    undeliveredStopsSectionTitle = "Colis non pris en charge — retirer de la tournée",
    removedStopNoticePrefix = "«",
    removedStopNoticeMiddle = "» retirée de la tournée — 1 arrêt en moins",
    remainingStopsSuffix = "restants",
    confirmAndStartButton = "Confirmer et démarrer la tournée",
    loadingOnBehalfOfLabel = "Pour le compte de",
    loadingExpectedLabel = "Chargement prévu",
    loadingQuestionTitle = "Avez-vous chargé tous les colis ?",
    loadingAllLoadedPrefix = "Oui, les",
    loadingAllLoadedSuffix = "colis sont à bord",
    loadingIncompleteOption = "Chargement incomplet",
    loadingIncompleteHint = "Je retire les arrêts concernés ou je justifie",
    loadingIncompleteRemoveLabel = "Et/ou retirez les arrêts non chargés",
    slideToStartLabel = "Glissez pour démarrer",
    completeRouteButton = "Terminer la tournée",
    completeRouteDialogTitle = "Terminer la tournée ?",
    completeRouteDialogPendingCountSuffix = "livraisons n'ont pas encore été traitées",
    completeRouteDialogPendingNote = "Elles seront marquées en échec avec le motif indiqué ci-dessous. Vous êtes responsable de ces livraisons non traitées.",
    completeRouteDialogBody = "Cette action est définitive : la tournée passera au statut « Terminée » et ne pourra plus être modifiée.",
    completeRouteDialogBodyAllTreated = "Toutes les livraisons ont été traitées. La tournée passera au statut « Terminée » et ne pourra plus être modifiée.",
    completeRouteDialogConfirm = "Terminer",
    completeRouteDialogReasonLabel = "Motif (facultatif)",
    completeRouteDialogReasonPlaceholder = "Expliquez pourquoi ces livraisons n'ont pas été traitées…",
    completeRouteDialogNoReasonWarning = "Si vous n'indiquez pas de motif, les arrêts restants seront enregistrés comme non livrés, par la faute du transporteur.",
    routeCompletedMessage = "Tournée terminée.",
    stopStatusUntreatedLabel = "Non traité",
    errorCompleteRouteStatusConflict = "Cette tournée ne peut pas être terminée dans son état actuel.",
    errorCompleteRoutePendingStopsConflict = "Des livraisons sont encore en attente. Confirmez pour terminer quand même.",
    stopSearchOpenAction = "Rechercher un arrêt",
    stopSearchCloseAction = "Fermer la recherche",
    stopSearchPlaceholder = "Nom, adresse ou téléphone",
    stopSearchClearTextAction = "Effacer le texte",
    stopSearchResultCount = "%1 arrêts sur %2",
    stopSearchResultCountOne = "1 arrêt sur %1",
    stopSearchEmptyTitle = "Aucun arrêt ne correspond",
    stopSearchEmptyHint = "Vérifiez l'orthographe ou cherchez par adresse ou par téléphone.",
    stopSearchClearAction = "Effacer la recherche",
    stopPositionLabel = "n° %1",
    ),
    extra = RouteStringsExtraImpl(
    packageCountFieldLabel = "Nombre de colis",
    reoptimizeSuccessTitle = "Itinéraire re-optimisé",
    backToRouteButton = "Retour à la tournée",
    routeBatchMultiDriverLink = "Répartir entre plusieurs chauffeurs",
    routeBatchSelectTitle = "Répartir la tournée",
    routeBatchDeliveriesReadyLabel = "livraisons prêtes à être réparties",
    routeBatchDriversSectionTitle = "Chauffeurs",
    routeBatchDriversSelectedSuffix = "chauffeurs sélectionnés",
    routeBatchOptimizeToggleTitle = "Optimiser l'itinéraire",
    routeBatchOptimizeToggleHelp = "RoutaR répartit et ordonne les stops selon la distance. Désactivé : répartition équitable simple par nombre de stops, sans calcul de trajet.",
    routeBatchSubmitButtonPrefix = "Répartir entre",
    routeBatchDriversWord = "chauffeurs",
    routeBatchOptimizationUnavailable = "Service d'optimisation temporairement indisponible. La tournée n'a pas été créée — vérifiez votre connexion et réessayez, ou désactivez « Optimiser l'itinéraire » pour une répartition simple immédiate.",
    routeBatchPreviewTitle = "Aperçu de la répartition",
    routeBatchPreviewEyebrowMiddle = "livraisons réparties entre",
    routeBatchPreviewEyebrowSuffix = "chauffeurs",
    routeBatchStopsChipSuffix = "stops",
    routeBatchDistanceLabel = "Distance",
    routeBatchDurationLabel = "Durée estimée",
    routeBatchDistanceNotCalculated = "Non calculée",
    routeBatchOptimizeDisabledBanner = "Optimisation désactivée : répartition équitable par nombre de stops, sans calcul de distance ni d'ordre de passage.",
    routeBatchReoptimizeButton = "Ré-optimiser",
    routeBatchDispatchButton = "Valider et envoyer",
    errorRouteBatchAlreadyDispatched = "Cette tournée a déjà été envoyée aux chauffeurs — impossible de la modifier.",
    routeBatchDispatchedTitle = "Tournées envoyées !",
    routeBatchDispatchedSubtitleSuffix = "chauffeurs notifiés simultanément, chacun avec sa propre tournée programmée.",
    routeBatchStatRoutesLabel = "Tournées",
    routeBatchStatDeliveriesLabel = "Livraisons",
    routeBatchStatusLabel = "Statut",
    routeBatchStatusDispatchedValue = "Envoyée",
    routeBatchSentAtLabel = "Envoyé le",
    routeBatchPerDriverTitle = "Détail par chauffeur",
    routeBatchDriverScheduledStatus = "Programmée",
    routeBatchBackToHomeButton = "Retour à l'accueil",
    errorTooManyDrivers = "Vous ne pouvez pas sélectionner plus de 50 chauffeurs à la fois.",
    errorTooManyDeliveries = "Le lot ne peut pas dépasser 500 livraisons.",
    createRouteFabLabel = "Nouvelle tournée",
    createOwnRouteButtonLabel = "Créer / Optimiser ma tournée",
    createOwnRouteTitle = "Créer ma tournée",
    createOwnRouteDeliveriesCountSuffix = "livraisons prêtes",
    stopStatusEnRouteLabel = "En route",
    yesterdayDateLabel = "Hier",
    periodPastLabel = "Passé",
    periodTomorrowLabel = "Demain",
    viewRouteButton = "Voir la tournée",
    viewButton = "Voir",
    noRouteTomorrowTitle = "Rien de prévu pour demain",
    noRouteTomorrowSubtitle = "Planifie une tournée à l'avance pour l'avoir prête dès demain matin.",
    planRouteButtonLabel = "Planifier une tournée",
    myRoutesTodayTitle = "Vos tournées d'aujourd'hui",
    myRoutesTitle = "Vos tournées",
    weekdayShortNames = listOf("Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"),
    weekdayFullNames = listOf("Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"),
    monthNames = listOf("janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"),
    statRoutesTodayLabel = "Tournées aujourd'hui",
    statStopsTodayLabel = "Arrêts aujourd'hui",
    statOnTimeLabel = "À temps aujourd'hui",
    statAvgProgressLabel = "Avancement moyen",
    inProgressSectionTitle = "En cours",
    upcomingSectionTitle = "À venir",
    doneSectionTitle = "Terminées",
    seeAllLabel = "Voir tout",
    continueRouteButton = "Continuer la tournée",
    detailsLinkLabel = "Détails",
    deliveryProofTitle = "Valider la livraison",
    deliveryProofStatusSectionLabel = "Statut de la livraison",
    deliveryProofPhotoSectionLabel = "Photo justificative",
    deliveryProofPhotoHint = "Obligatoire pour valider",
    deliveryProofTakePhotoCta = "Prendre une photo",
    deliveryProofRetakePhotoCta = "Reprendre une photo",
    deliveryProofRetakeChipLabel = "Reprendre",
    deliveryProofCommentSectionLabel = "Commentaire",
    failureReasonRouteClosedByDriver = "Tournée clôturée par le chauffeur : arrêt non livré, par la faute du transporteur.",
    deliveryProofCommentRequiredSuffix = "obligatoire si échec",
    deliveryProofCommentPlaceholderOptional = "Optionnel — précisions sur la livraison…",
    deliveryProofCommentPlaceholderRequired = "Expliquez la raison de l'échec…",
    deliveryProofCommentRequiredError = "Un commentaire est requis en cas d'échec de livraison",
    deliveryProofSubmitButton = "Valider la livraison",
    deliveryProofErrorInvalidPhoto = "Photo illisible ou format non supporté. Reprenez la photo et réessayez.",
    deliveryProofAlreadyProcessedBanner = "Cet arrêt a déjà été traité et ne peut plus être modifié.",
    proofPhotoViewerDownloadLabel = "Télécharger",
    proofPhotoViewerCloseLabel = "Fermer",
    proofPhotoDownloadedMessage = "Photo enregistrée dans la galerie.",
    proofPhotoDownloadErrorMessage = "Impossible d'enregistrer la photo.",
    deliveryConfirmTitle = "Livraison validée",
    deliveryConfirmSuccessTitle = "Livraison confirmée",
    deliveryConfirmSuccessSubtitle = "La preuve a bien été enregistrée pour cet arrêt.",
    deliveryConfirmFailedTitle = "Échec enregistré",
    deliveryConfirmFailedSubtitle = "Le commentaire et la photo ont été transmis au gestionnaire.",
    deliveryConfirmRouteCompletedTitle = "Tournée terminée !",
    deliveryConfirmRouteCompletedSubtitle = "Tous les arrêts ont été traités.",
    deliveryConfirmValidatedAtLabel = "Validé le",
    deliveryConfirmNextStopEyebrowPrefix = "Arrêt suivant",
    deliveryConfirmGoToNextStopButton = "Aller à l'arrêt suivant",
    deliveryConfirmAllDoneMessage = "C'était le dernier arrêt de la tournée — pensez à la clôturer.",
    offlineBannerTitle = "Hors connexion",
    offlineBannerRouteSubtitle = "vos validations seront envoyées dès le retour du réseau",
    offlineBannerValidateSubtitle = "sera enregistré localement",
    offlineSyncingBannerTitle = "Synchronisation en cours",
    offlineSyncingSubtitleSuffix = "livraisons envoyées",
    offlineRetryBannerTitle = "Échec de synchronisation",
    offlineRetryBannerSubtitle = "nouvelle tentative au prochain retour réseau",
    offlineSyncSuccessToastSuffix = "livraisons synchronisées avec succès",
    offlineQueuedBadgePendingLabel = "En attente d'envoi",
    offlineQueuedBadgeSyncingLabel = "Envoi en cours",
    offlineQueuedBadgeFailedLabel = "Échec — réessai prévu",
    offlineQueuedBadgeConflictLabel = "Déjà traité ailleurs",
    offlineDismissConflictAction = "Effacer",
    offlineValidatedLocallyAtPrefix = "validé localement à",
    offlineAddStopRequiresConnectionSuffix = "(nécessite une connexion)",
    deliveryProofOfflineSubmitButton = "Enregistrer (synchro différée)",
    deliveryProofSavedLocallyTitle = "Enregistré localement",
    deliveryProofSavedLocallySubtitle = "Cette livraison sera envoyée automatiquement dès que la connexion sera rétablie.",
    routeScheduledBannerTitle = "Tournée pas encore démarrée",
    routeScheduledBannerSubtitle = "Démarrez la tournée pour pouvoir valider une livraison.",
    geocodeIssueTag = "Adresse non localisée",
    regeocodeAction = "Réessayer la géolocalisation",
    regeocodeSuccessMessage = "Adresses mises à jour",
    dashboardTitle = "Dashboard",
    viewAllAction = "Tout voir",
    deleteRouteDialogTitle = "Supprimer la tournée ?",
    deleteRouteDialogMessage = "Cette tournée sera supprimée définitivement. Cette action est irréversible.",
    errorRouteDeleteConflict = "Suppression indisponible : la tournée est en cours.",
    errorDriverHasActiveRoute = "Une autre tournée est actuellement en cours. Terminez-la avant de démarrer celle-ci.",
    routeBatchNoStopsTag = "Aucun arrêt",
    routeBatchNoStopsDialogTitle = "Chauffeur sans arrêt",
    routeBatchNoStopsDialogMessage = "Au moins un chauffeur n'a aucun arrêt assigné. Il recevra quand même une tournée vide s'il n'est pas retiré du lot. Envoyer quand même ?",
    routeBatchAddressesToReviewTag = "adresse(s) à vérifier",
    otherDeliveriesInImportLabel = "Autres livraisons de cet import",
    proofPhotoUnavailableLabel = "Photo non disponible",
    deliveryProofPhotoOptionalSectionLabel = "Photo (facultative)",
    proofWithoutPhotoLabel = "Sans photo",
    removeStopDialogTitle = "Supprimer cet arrêt ?",
    removeStopDialogMessage = "« {name} » ({count} colis) sera retiré de la tournée. Cette action est irréversible.",
    deliveryRemovedMessage = "Livraison supprimée",
    undoAction = "Annuler",
    callLaunchFailed = "Impossible de lancer l'appel sur cet appareil",
    keepDraftsDialogTitleOne = "Garder la livraison ?",
    keepDraftsDialogTitleMany = "Garder les {count} livraisons ?",
    keepDraftsDialogMessage = "Vous les avez saisies, mais elles ne sont pas encore dans la liste.",
    keepDraftsAction = "Garder",
    deliveriesAddedToRouteOne = "1 livraison ajoutée à la tournée",
    deliveriesAddedToRouteMany = "{count} livraisons ajoutées à la tournée",
    driverJoinedTeamMessage = "{name} a rejoint l'équipe",
    ownRouteCreatedNotOptimizedMessage = "Tournée créée dans l'ordre saisi : l'optimisation n'a pas pu être faite",
    draftExitTitle = "Quitter la création ?",
    draftExitMessageOne = "Vous avez ajouté 1 livraison ({packages} colis).",
    draftExitMessageMany = "Vous avez ajouté {count} livraisons ({packages} colis).",
    draftKeepAction = "Garder pour plus tard",
    draftDeleteDeliveriesAction = "Supprimer les livraisons",
    draftContinueAction = "Continuer la création",
    draftSavedMessage = "Brouillon enregistré",
    draftCardTitle = "Tournée en cours de création",
    draftForDate = "pour le {date}",
    draftResumeAction = "Reprendre",
    draftDeleteDialogTitle = "Supprimer le brouillon ?",
    draftDeleteDialogMessageOne = "La livraison ({packages} colis) déjà saisie sera supprimée. Cette action est irréversible.",
    draftDeleteDialogMessageMany = "Les {count} livraisons ({packages} colis) déjà saisies seront supprimées. Cette action est irréversible.",
    draftResumeImportTitle = "Reprendre la tournée en cours",
    draftImportAddsHint = "Les livraisons importées s'ajouteront à ce brouillon :",
    stopDeliveredAtPrefix = "Livré à",
    stopFailedAtPrefix = "Échec à",
    stopOnTimeLabel = "À l'heure",
    stopLateByPrefix = "En retard de",
    stopTimeLabel = "Temps",
    stopAfterStartSuffix = "après le départ",
    stopAfterPreviousSuffix = "après l'arrêt précédent",
    stopDriverCommentLabel = "Commentaire du chauffeur",
    stopPackagesLabel = "Colis",
    durationHoursUnit = "h",
    durationMinutesUnit = "min",
    ),
)
